export * from './company-form.descriptor'
export * from './company-tax-details-form.descriptor'
export * from './company-vat-details-form.descriptor'
export * from './company-address-form.descriptor'
export * from './company-documents-form.descriptor'
export * from './company-proof-of-address-form.descriptor'
